import Vue from 'vue';
import Vuex from 'vuex';

import { SET_USER, SET_CREDENTIALS } from '@/assets/src/store/mutation_types';

import { ENVIRONMENTS } from '@/assets/src/constants';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== ENVIRONMENTS.production,

  state: {
    user: null,
    credentials: null,
  },

  mutations: {
    [SET_USER](state: any, user: any) {
      state.user = user;
    },

    [SET_CREDENTIALS](state: any, credentials: any) {
      state.credentials = credentials;
    },
  },
});
